import { ObjectPropertyValidator } from "./ObjectPropertyValidator.js";
export const ObjectPropertyValidatorManager = {
    _validators: new Map(),
    registerValidators(validators) {
        validators.forEach((data) => this._validators.set(data.id, new ObjectPropertyValidator(data)));
    },
    getValidator(id) {
        const validator = this._validators.get(id);
        if (!validator)
            throw new Error(`Validator with ${id} does not exist`);
        return validator;
    },
};
